import AssignmentShow from './AssignmentShow'

const resource = {
  show: AssignmentShow
}

export default resource